import { useBroadcastChannel } from "@app-context/broadcastChannels/context";
import { useRefCallback } from "@enfusion-ui/hooks";
import { TextInput } from "@enfusion-ui/web-components";
import { useThisTab } from "@enfusion-ui/web-core";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import * as React from "react";

import {
  InspectorReportConfig,
  useInspectorContext,
} from "../../context/inspector/context";
import { ActionButton, ButtonArea, PathArea } from "./InspectorConfig";

export const ReportConfig: React.FC<{}> = () => {
  const { id } = useThisTab();
  const { config: configBase, setConfig } = useInspectorContext();
  const config = configBase as InspectorReportConfig;
  const { broadcastMessage } = useBroadcastChannel("inspector-channel");

  const handlePathChange = useRefCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setConfig({ ...config, path: e.target.value });
    },
    [config, config.path]
  );

  return (
    <>
      <PathArea>
        <TextInput
          hideLabel
          value={config.path}
          onChange={handlePathChange}
          label="Path"
        />
      </PathArea>
      <ButtonArea>
        <ActionButton
          icon={faPaperPlane}
          primary
          onClick={() => broadcastMessage(`${id}<=>send`)}
        >
          Subscribe
        </ActionButton>
      </ButtonArea>
    </>
  );
};
